module.exports = __webpack_public_path__ + "static/assets/3896ef45847d1a283ddb4178c791c6c1.svg";